import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import { Loadable } from '../base/components/Lodable'

const CuentaPagarApp = Loadable(lazy(() => import('./view/CuentasPagar')))
const CuentaPagarEntradaRegistroApp = Loadable(lazy(() => import('./view/CuentaPagarEntradaRegistro')))
const CuentaPagarMovimientoApp = Loadable(lazy(() => import('./view/CuentasPagarMovimiento')))

export const cuentasPagarRoutesMap = {
  pagar: {
    path: '/cuenta/pagar-entrada',
    name: 'Entrada',
    actionSecure: 'administrar',
  },
  pagarEntradaRegistro: {
    path: '/cuenta/pagar-entrada-registro',
    name: 'Nueva Cuenta por Entrada',
    actionSecure: 'administrar',
  },
  pagarMovimiento: {
    path: '/cuenta/pagar/movimiento',
    name: 'Movimientos de Pago',
    actionSecure: 'movimientos',
  },
}
const cuentasPagarRoutes = [
  {
    path: cuentasPagarRoutesMap.pagar.path,
    element: (
      <OperacionesProvider>
        <CuentaPagarApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: cuentasPagarRoutesMap.pagarEntradaRegistro.path,
    element: (
      <OperacionesProvider>
        <CuentaPagarEntradaRegistroApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: cuentasPagarRoutesMap.pagarMovimiento.path,
    element: (
      <OperacionesProvider>
        <CuentaPagarMovimientoApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]
export default cuentasPagarRoutes
